import ReportTypes from '../types/ReportTypes';

const initialState = {
  isLoading: false,
  summaryData: [],
  summaryFilterData: {},
  ageingData: [],
  ageingFilterData: {},
  filterData: {},
  departmentReportData: {},
  clientReportData: {}
};

// eslint-disable-next-line default-param-last
const report = (state = initialState, action) => {
  switch (action.type) {
    case ReportTypes.GET_SUMMARY_REPORT_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case ReportTypes.GET_SUMMARY_REPORT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        summaryData: action.payload
      };
    case ReportTypes.GET_SUMMARY_REPORT_ERROR:
      return {
        ...state,
        isLoading: false,
        summaryData: []
      };

    case ReportTypes.GET_AGEING_REPORT_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case ReportTypes.GET_AGEING_REPORT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        ageingData: action.payload
      };
    case ReportTypes.GET_AGEING_REPORT_ERROR:
      return {
        ...state,
        isLoading: false,
        ageingData: []
      };

    case ReportTypes.GET_REPORT_FILTER_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case ReportTypes.GET_REPORT_FILTER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        filterData: action.payload
      };
    case ReportTypes.GET_REPORT_FILTER_ERROR:
      return {
        ...state,
        isLoading: false,
        filterData: {}
      };

    case ReportTypes.GET_SUMMARY_REPORT_FILTER_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case ReportTypes.GET_SUMMARY_REPORT_FILTER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        summaryFilterData: action.payload
      };
    case ReportTypes.GET_SUMMARY_REPORT_FILTER_ERROR:
      return {
        ...state,
        isLoading: false,
        summaryFilterData: []
      };

    case ReportTypes.GET_AGEING_REPORT_FILTER_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case ReportTypes.GET_AGEING_REPORT_FILTER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        ageingFilterData: action.payload
      };
    case ReportTypes.GET_AGEING_REPORT_FILTER_ERROR:
      return {
        ...state,
        isLoading: false,
        ageingFilterData: []
      };

    case ReportTypes.CLIENT_BASED_REPORT_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case ReportTypes.CLIENT_BASED_REPORT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        departmentReportData: {},
        clientReportData: action.payload
      };
    case ReportTypes.CLIENT_BASED_REPORT_ERROR:
      return {
        ...state,
        isLoading: false,
        clientReportData: {}
      };
    case ReportTypes.DEPARTMENT_BASED_REPORT_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case ReportTypes.DEPARTMENT_BASED_REPORT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        clientReportData: {},
        departmentReportData: action.payload
      };
    case ReportTypes.DEPARTMENT_BASED_REPORT_ERROR:
      return {
        ...state,
        isLoading: false,
        departmentReportData: {}
      };

    default:
      return state;
  }
};
export default report;
